interface CtaSectionProps {
  onRegisterClick: () => void;
}

export default function CtaSection({ onRegisterClick }: CtaSectionProps) {
  const badges = [
    { icon: '📅', text: '16–17 апреля 2026' },
    { icon: '📍', text: 'Гостиница «Москва», Санкт-Петербург' },
    { icon: '🎤', text: 'Медицинский стендап «Смехосоматика»' },
    { icon: '🤖', text: 'AI-болит во время обеда' },
    { icon: '🚶', text: 'Прогулка по центру Питера' },
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/img/cta-participants.png"
          alt="Участники NeuroRussia"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f3d32]/90 via-[#0f3d32]/75 to-[#0f3d32]/50"></div>
      </div>

      <div className="absolute top-0 right-0 w-96 h-96 bg-[#c8963e]/10 rounded-full -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/3"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#c8963e] mb-5">
          Не пропустите
        </span>
        <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-5 leading-tight">
          Присоединяйтесь<br />к NeuroRussia 2026
        </h2>
        <p className="text-white/75 text-lg md:text-xl mb-10 leading-relaxed max-w-2xl mx-auto">
          Два дня междисциплинарных диалогов + медицинский стендап + AI-консультант + Санкт-Петербург
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {badges.map((b) => (
            <span key={b.text} className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-4 py-2.5 text-white text-sm font-medium">
              <span>{b.icon}</span>
              <span>{b.text}</span>
            </span>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onRegisterClick}
            className="bg-[#e8a030] hover:bg-[#f0aa35] text-white font-extrabold text-base px-12 py-4 rounded-full transition-all hover:-translate-y-1 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 4px 28px 0 rgba(232,160,48,0.5)' }}
          >
            Зарегистрироваться бесплатно
          </button>
          <a href="/program16.pdf" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/60 text-white font-semibold text-sm px-7 py-4 rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-download-line"></i>Программа 16.04 (PDF)
          </a>
          <a href="/program17.pdf" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/60 text-white font-semibold text-sm px-7 py-4 rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-download-line"></i>Программа 17.04 (PDF)
          </a>
        </div>
      </div>
    </section>
  );
}
